const CONDITION_NEW: string = 'new'
const CONDITION_USED: string = 'used'
const CONDITION_REFURBISHED: string = 'refurbished'
const CONDITION_DISCOUNT: string = 'p_discount'
const CONDITION_UNDETERMINED: string = 'w_undetermined'

export {
  CONDITION_NEW,
  CONDITION_USED,
  CONDITION_REFURBISHED,
  CONDITION_DISCOUNT,
  CONDITION_UNDETERMINED
}
